var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.61342 9.21927C1.52262 9.07551 1.47723 9.00363 1.45182 8.89276C1.43273 8.80948 1.43273 8.67815 1.45182 8.59487C1.47723 8.484 1.52262 8.41212 1.61341 8.26836C2.36369 7.08038 4.59693 4.07715 8.00027 4.07715C11.4036 4.07715 13.6369 7.08038 14.3871 8.26836C14.4779 8.41212 14.5233 8.484 14.5487 8.59487C14.5678 8.67815 14.5678 8.80948 14.5487 8.89276C14.5233 9.00363 14.4779 9.07551 14.3871 9.21927C13.6369 10.4073 11.4036 13.4105 8.00027 13.4105C4.59693 13.4105 2.36369 10.4073 1.61342 9.21927Z",
    stroke: "#98A2B3",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00027 10.7438C9.10484 10.7438 10.0003 9.84838 10.0003 8.74382C10.0003 7.63925 9.10484 6.74382 8.00027 6.74382C6.8957 6.74382 6.00027 7.63925 6.00027 8.74382C6.00027 9.84838 6.8957 10.7438 8.00027 10.7438Z",
    stroke: "#98A2B3",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.eb683f1c6c16950ec25473fd65721997.svg";
export { ForwardRef as ReactComponent };